export default {
  common: {
    header: {
      title: "开启你的无忧奢华之旅"
    },
    hour: "小时",
    hours: "小时",
    order: "订单"
  }
};
